import { INote } from "../../types/INote";
import { Helmet } from "react-helmet";
import { useState, useEffect } from "react";
import { LiveBlogPosting, WithContext } from "schema-dts";
import { ILiveType } from "../../types/ILiveType";
import { createStructuredData } from "../../services/structured-data-factory";
import { IPageData } from "../../types/IPageData";

interface Props {
  articleId: IPageData["articleId"];
  notes: INote[];
  liveType: ILiveType;
}

const StructuredData: React.FC<Props> = ({ articleId, notes, liveType }) => {
  const [structuredData, setStructuredData] = useState<WithContext<LiveBlogPosting>>();

  useEffect(() => {
    if (!structuredData && notes.length > 0) {
      createStructuredData({ articleId, notes, liveType })
        .then((data) => {
          setStructuredData(data);
        })
        .catch((e) => {
          console.error("Structured Data Component Error!", e);
        });
    }
  }, [structuredData, notes]);

  if (!structuredData) {
    return null;
  }

  return (
    <Helmet>
      <script type="application/ld+json" data-e="notes-structured-data">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
